// eslint-disable-next-line @typescript-eslint/no-explicit-any -- the locale files are plain JavaScript: they carry no types
type Untyped = any;

// The same `localizations[lang] || localizations.en` rule the store follows,
// by section: a locale that ships without the tours keeps the English tour.
export function tourStrings(localizations: Untyped, lang: string | undefined): Untyped {
    return localizations?.[lang ?? '']?.tours ?? localizations?.en?.tours ?? {};
}
